import React from "react";

// mui components
import { List, ListItem, ListItemText, Modal, Stack } from "@mui/material";
import { HelpOutlineOutlined } from "@mui/icons-material";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";

// custom components
import PrimaryButton from "../../buttons/primary-button";
import NestedText from "../../typography/nested-text";
import Heading4 from "../../typography/heading-04";
import Body2 from "../../typography/body-02";

// custom styles
import styles from "./index.module.scss";

export default function CondotelHelpTextModal({ open, handleClose }) {
	return (
		<Modal
			open={open}
			aria-labelledby="loading modal"
			aria-describedby="loading modal"
			disableAutoFocus={true}
			disableEscapeKeyDown={true}
		>
			<Stack direction="column" className={styles.modalBodyContainer}>
				<Stack
					direction="row"
					justifyContent="center"
					className={styles.modalHeadingContainer}
				>
					<HelpOutlineOutlined className={styles.modalHeadingIcon} />
					<Heading4
						text="Help Text"
						fontType="semibold"
						extraClass={styles.modalHeadingText}
					/>
				</Stack>
				<Stack direction="column" gap={1} className={styles.modalText}>
					<Stack
						flexDirection="row"
						sx={{ textDecoration: "underline", textUnderlineOffset: "2px" }}
					>
						<Body2
							extraClass={styles.helpCentreTitle}
							text="To select a Condotel product, follow these steps:"
							fontType="semibold"
						/>
					</Stack>

					<List
						sx={{ listStyleType: "decimal", pl: 4, verticalAlign: "middle" }}
						className={styles.mainList}
					>
						<ListItem disablePadding sx={{ display: "list-item" }}>
							<ListItemText
								disableTypography={true}
								primary={
									<Body2
										extraClass={styles.helpCentreText}
										text="Select Property Type"
										fontType="semibold"
									/>
								}
							/>

							<List
								sx={{ listStyleType: "none", pl: 4, verticalAlign: "middle" }}
								className={styles.subList}
							>
								<ListItem disablePadding sx={{ display: "list-item" }}>
									<ListItemText
										disableTypography={true}
										primary={
											<Stack direction="row" gap="3px">
												<Body2 text="Choose either" />
												<Body2 text="Condominium" fontStyle="italic" />
												<Body2 text="or" />
												<Body2
													text="High Rise Condominium."
													fontStyle="italic"
												/>
											</Stack>
										}
									/>
								</ListItem>
							</List>
						</ListItem>
						<ListItem disablePadding sx={{ display: "list-item" }}>
							<ListItemText
								disableTypography={true}
								primary={
									<Body2
										extraClass={styles.helpCentreText}
										text="Enter Number of Stories"
										fontType="semibold"
									/>
								}
							/>

							<List
								sx={{ listStyleType: "none", pl: 4, verticalAlign: "middle" }}
								className={styles.subList}
							>
								<ListItem disablePadding sx={{ display: "list-item" }}>
									<ListItemText
										disableTypography={true}
										primary={
											<NestedText extraText="Enter the total number of stories in the building." />
										}
									/>
								</ListItem>
							</List>
						</ListItem>
						<ListItem disablePadding sx={{ display: "list-item" }}>
							<ListItemText
								disableTypography={true}
								primary={
									<Body2
										extraClass={styles.helpCentreText}
										text="High Rise Classification"
										fontType="semibold"
									/>
								}
							/>

							<List
								sx={{ listStyleType: "none", pl: 4, verticalAlign: "middle" }}
								className={styles.subList}
							>
								<ListItem disablePadding sx={{ display: "list-item" }}>
									<ListItemText
										disableTypography={true}
										primary={
											<Stack direction="row" gap="3px">
												<Body2 text="If the building has" />
												<Body2 text="more than 8 stories" fontType="semibold" />
												<Body2 text=", select" />
												<Body2
													text="High Rise Condominium."
													fontStyle="italic"
												/>
											</Stack>
										}
									/>
									<ListItemText
										disableTypography={true}
										primary={
											<Stack direction="row" gap="3px">
												<Body2 text="If it has" />
												<Body2 text="8 or fewer" fontType="semibold" />
												<Body2 text=", select" />
												<Body2 text="Condominium." fontStyle="italic" />
											</Stack>
										}
									/>
								</ListItem>
							</List>
						</ListItem>
						<ListItem disablePadding sx={{ display: "list-item" }}>
							<ListItemText
								disableTypography={true}
								primary={
									<Body2
										extraClass={styles.helpCentreText}
										text="Enable Condotel"
										fontType="semibold"
									/>
								}
							/>

							<List
								sx={{ listStyleType: "none", pl: 4, verticalAlign: "middle" }}
								className={styles.subList}
							>
								<ListItem disablePadding sx={{ display: "list-item" }}>
									<ListItemText
										disableTypography={true}
										primary={
											<Stack direction="row" gap="3px">
												<Body2 text="Set " />
												<Body2 text="Condotel?" fontType="semibold" />
												<Body2 text="to “Yes”." />
											</Stack>
										}
									/>
								</ListItem>
							</List>
						</ListItem>
					</List>

					<Stack flexDirection="row" alignItems="center" gap="2px">
						<ReportProblemOutlinedIcon className={styles.modalHeadingIcon} />
						<Body2
							extraClass={styles.helpCentreFooterText}
							text="Reminder: Proper classification is required for accurate product eligibility and pricing."
						/>
					</Stack>
				</Stack>
				<PrimaryButton
					text="Return to portal"
					extraClass={styles.backButton}
					onClick={handleClose}
				/>
			</Stack>
		</Modal>
	);
}
